import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  Input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ReactiveFormsModule, FormControl, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { NgToastService } from 'ng-angular-popup';
import { MatError, MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RichTextEditorComponent } from '@/app/components/shared/rich-textEditor/rich-textEditor.component';
import { EoiSectionsComponent } from '../eoi-sections.component';
import { Router } from '@angular/router';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { SubmissionGuidelineEoi } from '@/app/interfaces/submission-guideline-eoi.interface';
import { DateFormatService } from '@/app/services/date-format.service';
@Component({
  selector: 'app-submission-guidlines',
  standalone: true,
  providers: [provideNativeDateAdapter()],
  imports: [
    MatChipsModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    RichTextEditorComponent,
    MatDatepickerModule,
    MatError,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './submission-guidlines.component.html',
  styleUrl: './submission-guidlines.component.css',
})
export class SubmissionGuidlinesComponent implements OnInit {
  @Output() closeModalEvent = new EventEmitter<boolean>(); // EventEmitter to notify parent
  @Input() eoiId!: number;
  @Input() projectId!: number;
  @Input() currentEOISavedData: any = [];
  @Output() responseEmitter = new EventEmitter<any>();

  eoiTitle: FormControl<any>;
  projectName: string;
  form: FormGroup;
  resetRichTextEditor = false;
  closeModal = true;
  projectIdentifier: string;

  constructor(
    private EoiSectionsComponent: EoiSectionsComponent,
    private toast: NgToastService,
    private router: Router,
    private tenderingService: TenderingService,
    private DateFormatService: DateFormatService
  ) {}

  ngOnInit(): void {
    this.projectName = localStorage.getItem('project-name');
    this.form = new FormGroup({
      issueOfEOI: new FormControl('', Validators.required),
      eoiSubmissionClosing: new FormControl('', Validators.required),
      eoiInquiryDeadline: new FormControl('', Validators.required),
      floatEPCTender: new FormControl('', Validators.required),
      // eligibilityCriteria: new FormControl('', Validators.required),
      eligibilityCriteria: new FormControl(''),
    });

    // Map the fetched work packages to the expected format
    if (this.currentEOISavedData?.eoiData) {
      this.form.controls['issueOfEOI'].setValue(
        this.currentEOISavedData.eoiData?.issue_date
      );
      this.form.controls['eoiSubmissionClosing'].setValue(
        this.currentEOISavedData.eoiData?.submission_date
      );
      this.form.controls['eoiInquiryDeadline'].setValue(
        this.currentEOISavedData.eoiData?.inquiry_deadline
      );
      this.form.controls['floatEPCTender'].setValue(
        this.currentEOISavedData.eoiData?.epc_date
      );
      this.form.controls['eligibilityCriteria'].setValue(
        this.currentEOISavedData.eoiData?.eligibility_criteria || ''
      );
    }
    this.projectIdentifier = this.tenderingService.getProjectIdentifier();
  }

  eligibilityCriteria(content: string) {
    this.form.controls['eligibilityCriteria'].setValue(content);
  }

  moveToPreviousStep() {
    this.EoiSectionsComponent.previousStep();
  }

  prepareDataToSubmit() {
    // !this.form.value.eligibilityCriteria ||
    if (!this.form.valid) {
      this.toast.danger('Please fill all fields', 'WARNING', 4000);
      return false;
    }

    const data = {
      eoi_id: this.eoiId,
      issue_date: this.DateFormatService.formatDate(this.form.value.issueOfEOI),
      submission_date: this.DateFormatService.formatDate(
        this.form.value.eoiSubmissionClosing
      ),
      inquiry_deadline: this.DateFormatService.formatDate(
        this.form.value.eoiInquiryDeadline
      ),
      epc_date: this.DateFormatService.formatDate(
        this.form.value.floatEPCTender
      ),
      eligibility_criteria: this.form.value.eligibilityCriteria,
    };
    return data;
  }

  moveToNextStep() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const dataToSubmit = this.prepareDataToSubmit();

    if (dataToSubmit) {
      this.tenderingService
        .storeEOIStep3Data(dataToSubmit, this.eoiId)
        .subscribe({
          next: (response: SubmissionGuidelineEoi) => {
            if (response.meta.success) {
              this.toast.success('Guidlines Submitted', 'SUCCESS');
              this.responseEmitter.emit({
                eoiId: this.eoiId,
                projectId: this.projectId,
                updatedSubmissionGuidelines: response?.data,
              });
              // TODO: do we need it here?
              // Yes because this is the last step and we have to move on to the view page
              this.closeModalEvent.emit(this.closeModal); // Emit closeModal value to the parent
              this.router.navigate(
                ['/initiate-eoi', this.projectId, this.eoiId],
                {
                  queryParams: { projectName: this.projectName, projectIdentifier: this.projectIdentifier },
                }
              );
            }
          },
          error: (error: any) => {
            console.error('Failed to submit:', error);
            this.toast.danger(error.error.message, 'DANGER', 4000);
          },
        });
    }
  }

  handleBack() {
    this.EoiSectionsComponent.previousStep();
  }

  fetchEoiStep3Data() {
    this.tenderingService.fetchEoiStep1Data().subscribe({
      next: (response: any) => {
        console.log('The response of EOI is:', response);
      },
      error: (error: any) => {
        console.error('Failed to fetch:', error);
      },
    });
  }
}
